import { useQuery } from '@tanstack/react-query'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import { useAllowPickupOrderFeature } from '@/hooks/useAllowPickupOrderFeature'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { getUserPickupOrders } from '../../user-package/userPkgService'

export const useUserPickupOrders = () => {
  const { data: loggedUser } = useCurrentUser()
  const { allowPickupOrderFeature } = useAllowPickupOrderFeature()
  return useQuery({
    queryKey: [QUERY_KEYS.USER_PICKUP_ORDERS],
    queryFn: () => getUserPickupOrders(),
    enabled: allowPickupOrderFeature && !!loggedUser?.id,
  })
}
